var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 16.714 2 19.071 3.464 20.535C4.93 22 7.286 22 12 22C16.714 22 19.071 22 20.535 20.535C22 19.072 22 16.714 22 12V10.5M13.5 2H12C7.286 2 4.929 2 3.464 3.464C2.491 4.438 2.164 5.807 2.055 8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.652 3.45512L17.301 2.80612C17.8174 2.28988 18.5177 1.99991 19.2479 2C19.978 2.00009 20.6783 2.29024 21.1945 2.80662C21.7107 3.323 22.0007 4.0233 22.0006 4.75347C22.0005 5.48365 21.7104 6.18388 21.194 6.70012L20.544 7.34912C20.544 7.34912 19.166 7.26812 17.95 6.05112C16.733 4.83512 16.652 3.45612 16.652 3.45612L10.687 9.42012C10.283 9.82412 10.081 10.0261 9.907 10.2491C9.702 10.5111 9.527 10.7961 9.383 11.0971C9.262 11.3521 9.172 11.6231 8.991 12.1651L8.412 13.9001M8.412 13.9001L8.038 15.0221C7.99402 15.153 7.98741 15.2935 8.01892 15.4279C8.05043 15.5623 8.11881 15.6853 8.21638 15.7829C8.31394 15.8806 8.43682 15.9491 8.57119 15.9808C8.70556 16.0124 8.8461 16.006 8.977 15.9621L10.1 15.5881M8.412 13.9001L10.1 15.5881M20.545 7.34812L17.562 10.3301M14.58 13.3131C14.176 13.7171 13.974 13.9191 13.751 14.0931C13.4882 14.2981 13.2039 14.4738 12.903 14.6171C12.648 14.7381 12.377 14.8281 11.835 15.0091L10.1 15.5881",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign-in.5d90b779748028e8492cf1a0392006bd.svg";
export { ForwardRef as ReactComponent };